import axios from 'axios'
import { useUserStore } from '../stores/user-store'
import { useToast } from 'vuestic-ui'

const { init } = useToast()
const apiUrl = import.meta.env.VITE_API_BASE_URL
axios.defaults.baseURL = apiUrl

axios.interceptors.request.use(
  (request) => {
    // Do something before request is sent
    const userStore = useUserStore()

    // If request isn't in urlsExcludedForBearerHeader
    // send Authorization header with token from userStore
    const urlsExcludedForBearerHeader = ['/login', '/password-recovery', '/password-reset']
    if (urlsExcludedForBearerHeader.indexOf(request?.url ?? '') === -1 && userStore.token) {
      request.headers['Authorization'] = `Bearer ${userStore.token}`
    }
    return request
  },
  (err) => {
    // Do something with request error
    return Promise.reject(err)
  },
)

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (err) => {
    // Do something with response error
    const errMessage = err.response?.data?.errors ?? err.response?.data?.errors ?? err

    let txtError = ''
    if (errMessage instanceof Object) {
      Object.keys(errMessage).forEach((key) => {
        txtError += errMessage[key]
      })
    }

    if (err.response?.status === 401) {
      const userStore = useUserStore()
      userStore.logout()
      return Promise.reject(err)
    }

    init({
      message: txtError != '' ? txtError : errMessage,
      color: 'danger',
    })

    return Promise.reject(err)
  },
)
